
const FILTERED_BOOKS_PAGE_TEMPLATE = `

<section id="filterbuttons-component" class="container mtop-10">
    <div class="col-lg-12">
        <% for (var [filter, value] of Object.entries(filters)) { %>
            <% for (var i = 0; i < value.length; i++) { %>
                <div class="active-refinement" data-filterType="<% filter %>">
                    <a class="btn btn-primary btn-contrast btn-fixed btn-xs remove-toggle left" 
                        data-filter="<%= value[i] %>" 
                        onclick="app.components.filters.removeSelectionByIndex('<%= filter %>', <%= i %>)">
                        <span class="remove-toggle">
                            <i class="fa fa-close"></i>
                        </span>
                        <span class="sr-online"></span>
                        <% if (filter === "country") { %> 
                            <span><%= app.localeManager.get("country." + value[i].toLowerCase()) %></span>
                        <% } else if (filter === "reading_level") { %> 
                            <span><%= app.localeManager.get("levels." + value[i].toLowerCase()) %></span>    
                        <% } else { %>
                            <span><%= app.localeManager.get(filter + "s." + value[i].toLowerCase()) %></span>
                        <% } %>
                    </a>
                </div>
            <% } %>
        <% } %>
    </div>
</section>
<section id="bookView"></section>
`;

const FilteredBooksPage = Backbone.View.extend({

    id: "filtered-books-page",
    
    className: "container",

    template: _.template( FILTERED_BOOKS_PAGE_TEMPLATE ),

    // The subcomponents of the page
    components: {
        bookView: {},
    },

    collection: {},

    filters: {},

    afterRender: function() {
        // The filter buttons must be between the books and the alphafilter
        // This isn't pretty but I couldn't find a better way to do it
        // Ideally this view should not know the ids of its components
        this.$el.find("#filterbuttons-component").appendTo("#alphafilter-component");

        this.components.bookView.afterRender();
    },

    initialize: function(options) {
        // override the default constructor to accept additional parameters
        this.options = options || {};
        this.filters = this.options.filters;

        // initialize the subcomponents
        this.components.bookView = new DynamicBookCollectionView({ collection: this.collection });
    },

    render: function() {
        this.$el.html(this.template({ filters: this.filters }));
        this.$el.find("#bookView").html(this.components.bookView.render().el);

        return this;
    },

});